import PropTypes from 'prop-types';
import React from 'react';
import ReactSimpleCurrency from './SimpleCurrency';
import withOverridableCurrency from './hoc/withOverridableCurrency';

const SimpleCurrencyInput = ({ wrapperClassName, addPrefix, prefix, currencySymbol, ...simpleCurrencyProps }) => (
  <div className={wrapperClassName}>
    <span className="c-prefix" display-if={addPrefix}>{prefix || currencySymbol}</span>
    <ReactSimpleCurrency {...simpleCurrencyProps} />
  </div>
);

SimpleCurrencyInput.propTypes = {
  wrapperClassName: PropTypes.string,
  prefix: PropTypes.string,
  addPrefix: PropTypes.bool,
  currencySymbol: PropTypes.string,
};

SimpleCurrencyInput.defaultProps = {
  wrapperClassName: '',
  prefix: '',
  addPrefix: false,
  currencySymbol: '$',
};

export default withOverridableCurrency(SimpleCurrencyInput);
